import gql from 'graphql-tag'

export default gql`
  mutation destroyCashflowData($resourceType: String! $resourceId: Int!, $dataKeys: [CashflowDataKeys!]!) {
    destroyCashflowData(input: { resourceType: $resourceType, resourceId: $resourceId, dataKeys: $dataKeys }) {
      cashflowData {
        rid
      }
    }
  }
`
